import { render, staticRenderFns } from "./VuesticChat.vue?vue&type=template&id=4e46c242&scoped=true"
import script from "./VuesticChat.vue?vue&type=script&lang=js"
export * from "./VuesticChat.vue?vue&type=script&lang=js"
import style0 from "./VuesticChat.vue?vue&type=style&index=0&id=4e46c242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e46c242",
  null
  
)

export default component.exports